// extracted by mini-css-extract-plugin
export default {"root":"Info-root-996923fe659288e5cfc095813fdb3eec"};